import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {Card, Col, Layout, Modal, Row} from 'antd';

import './HomeScreen.css';
import {withRouter} from 'react-router-dom';
import SAInputSearch from "../components/common/input/SAInputSearch";
import SAButton from "../components/common/button/SAButton";

const { Content } = Layout;

class ChangeDealerScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDealer: null,
      fetchMyDealerStarted: false,
      dealers:this.props.dealers,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (this.state.fetchMyDealerStarted && nextProps.selectedDealer) {
      this.setState({ fetchMyDealerStarted: false });
      this.props.closeChangeDealerModal();
    }
  }

  onSelectDealerClosure = dealer => () => {
    this.setState({ selectedDealer: dealer });
    this.props.dispatchSaveSelectedDealer({selectedDealer:dealer})
  };

  renderDealer = (dealer, formatMessage) => (
    <Card
      key={dealer.connectedId}
      bodyStyle={{ padding: 0, backgroundColor: dealer.notSupported ? 'grey' : 'white', cursor: dealer.notSupported ? 'not-allowed' : 'grab', color: dealer.notSupported ? 'white':'black'}}
      style={{
        paddingBottom: 0,
        marginBottom: '5px',
        borderWidth:
          this.state.selectedDealer &&
          this.state.selectedDealer.connectedId === dealer.connectedId
            ? '4px solid'
            : null,
        borderColor:
          this.state.selectedDealer && this.state.selectedDealer.connectedId === dealer.connectedId ? 'blue' : null,
      }}
      bordered
      onClick={!dealer.notSupported && this.onSelectDealerClosure(dealer)}
    >
      <Row type="flex" style={{ padding: 10 }} gutter={16}>
        <Col span={12} style={{ margin: 'auto' }}>
          <Row style={{ fontWeight: 'bold' }}>{dealer.dealerName}</Row>
          <Row>
            {dealer.address.street1}, {dealer.address.city}, {dealer.address.zipcode},{' '}
            {dealer.address.country}
          </Row>
          {dealer.notSupported && <Row>{formatMessage({id: 'customer.home.changeDealer.notSupported'})}</Row>}
        </Col>
      </Row>
    </Card>
  );

  handleChoose = () => {
    const connectedId = this.state.selectedDealer.id;
    if (this.props.myDealer && this.props.myDealer.id === connectedId) {
      this.props.closeChangeDealerModal();
      return;
    }
    this.setState({ fetchMyDealerStarted: true });
    this.props.dispatchFetchMyDealer({ connectedId: this.state.selectedDealer.connectedId });
  };

  handleClose = () => {
    this.props.closeChangeDealerModal();
  };

  searchDealer = (value) => {
    const {dealers} =this.props;
    if (!value || value.trim() === ''){
      this.setState({dealers});
    }
    const filtered = dealers.filter(d=>
      this.fieldMatch(d.dealerName, value) ||
      this.fieldMatch(d.address.city, value) ||
      this.fieldMatch(d.address.street1, value) ||
      this.fieldMatch(d.address.zipcode, value));

    this.setState({dealers:filtered});
  };

  fieldMatch= (field, value) => {
    if (!value){
      return true;
    }
    if (!field){
      return false;
    }
    return field.toLowerCase().includes(value.toLowerCase());

  }

  render() {
    const {
      intl: { formatMessage },
      changeDealerModal,
      vehicle,
    } = this.props;

    const {dealers} = this.state;
    if (!dealers) {
      return <div>{formatMessage({id: 'customer.home.changeDealer.noDealer'})}</div>;
    }

    let filteredDealer = dealers;
    if (vehicle) {
      filteredDealer = dealers.map(d => {
        if(!d.supportedBrands.includes(vehicle.brand)){
          d.notSupported = true;
        }
        return d;
      });
    }

    return (
      <Modal
        title={formatMessage({id: 'customer.home.changeDealer.title'})}
        visible={changeDealerModal}
        onCancel={this.handleClose}
        bodyStyle={{maxHeight:'500px', overflowY:'scroll'}}
        footer={
          <Row type={"flex"} gutter={16}>
            <Col lg={12}>
              <SAButton
                key="back"
                type="secondary"
                onClick={this.handleClose}
              >
                {formatMessage({id: 'action.cancel'})}
              </SAButton>
            </Col>
            <Col lg={12}>
              <SAButton
                type="primary"
                disabled={!this.state.selectedDealer}
                onClick={this.handleChoose}
              >
                {formatMessage({id: 'action.select'})}
              </SAButton>
            </Col>
          </Row>
        }
      >
        <Layout className="layout">
          <Content style={{ margin: '0 auto', width: '100%' }}>
            {this.props.dealers.length > 5 && <SAInputSearch onSearch={this.searchDealer}/>}
            {filteredDealer.map(d => this.renderDealer(d, formatMessage))}
          </Content>
        </Layout>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchMyDealer: params => dispatch({ type: 'FETCH.MY_DEALER.REQUEST', params }),
  dispatchSaveSelectedDealer: params => dispatch({ type: 'SAVE.SELECTED_DEALER', params }),
  closeChangeDealerModal: () =>
    dispatch({ type: 'SHOW.CHANGE_DEALER_MODAL', changeDealerModal: false }),
});

const mapStateToProps = state => ({
  vehicles: state.vehicles.vehicles,
  loading: state.vehicles.loading,
  changeDealerModal: state.customerDealer.changeDealerModal,
  selectedDealer: state.customerDealer.selectedDealer,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(ChangeDealerScreen))
);



// WEBPACK FOOTER //
// ./src/public/ChangeDealerScreen.js